import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';

const prismMenuBaseCss = ".pwc-menu-wrapper{display:none;position:absolute;background-color:var(--prism-color-theme-surface-variant);border-radius:var(--prism-border-radius-global-normal);overflow:auto;padding:var(--prism-spacing-global-medium) 0;min-width:6rem;max-width:25rem;max-height:32.5rem;width:inherit;height:fit-content;outline:none;box-shadow:0 8px 10px 0 rgba(57, 60, 84, 0.2), 0 6px 30px 5px rgba(57, 60, 84, 0.1215686275), 0 16px 24px 2px rgba(57, 60, 84, 0.1411764706)}.pwc-visible{display:block}";
const PrismMenuBaseStyle0 = prismMenuBaseCss;

const sharedCss = ".prism-headline-mega{font-size:var(--prism-typography-global-type-scale-step8);font-family:var(--prism-typography-global-font-family-heading);font-weight:var(--prism-typography-global-font-weight-bold);line-height:var(--prism-typography-global-line-height-smallest);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-20);text-transform:uppercase;}.prism-headline-mega-inlined{font-size:var(--prism-typography-global-type-scale-step8);font-family:var(--prism-typography-global-font-family-heading-inline);font-weight:var(--prism-typography-global-font-weight-regular);-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:var(--prism-typography-global-line-height-smallest);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-90);text-transform:uppercase;}.prism-headline-2xl{font-size:var(--prism-typography-global-type-scale-step7);font-family:var(--prism-typography-global-font-family-heading);font-weight:var(--prism-typography-global-font-weight-bold);line-height:var(--prism-typography-global-line-height-smaller);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-30);text-transform:uppercase;}.prism-headline-2xl-inlined{font-size:var(--prism-typography-global-type-scale-step7);font-family:var(--prism-typography-global-font-family-heading-inline);font-weight:var(--prism-typography-global-font-weight-regular);-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:var(--prism-typography-global-line-height-smaller);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-100);text-transform:uppercase;}.prism-headline-xl{font-size:var(--prism-typography-global-type-scale-step6);font-family:var(--prism-typography-global-font-family-heading);font-weight:var(--prism-typography-global-font-weight-bold);line-height:var(--prism-typography-global-line-height-small);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-30);text-transform:uppercase;}.prism-headline-xl-inlined{font-size:var(--prism-typography-global-type-scale-step6);font-family:var(--prism-typography-global-font-family-heading-inline);font-weight:var(--prism-typography-global-font-weight-regular);-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:var(--prism-typography-global-line-height-small);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-100);text-transform:uppercase;}.prism-headline-large{font-size:var(--prism-typography-global-type-scale-step5);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-regular);line-height:var(--prism-typography-global-line-height-regular);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-30)}.prism-headline-medium{font-size:var(--prism-typography-global-type-scale-step4);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-bold);line-height:var(--prism-typography-global-line-height-regular);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-30);text-transform:uppercase;}.prism-headline-small{font-size:var(--prism-typography-global-type-scale-step3);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-bold);line-height:var(--prism-typography-global-line-height-regular);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-20)}.prism-headline-xs{font-size:var(--prism-typography-global-type-scale-step2);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-bold);line-height:var(--prism-typography-global-line-height-regular);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-40)}.prism-subtitle-1{font-size:var(--prism-typography-global-type-scale-step1);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-regular);line-height:var(--prism-typography-global-line-height-regular);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-20)}.prism-subtitle-2{font-size:var(--prism-typography-global-type-scale-step0);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-bold);line-height:var(--prism-typography-global-line-height-regular);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-40)}.prism-body-1,body{font-size:var(--prism-typography-global-type-scale-step0);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-regular);line-height:var(--prism-typography-global-line-height-large);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-40)}.prism-body-2{font-size:var(--prism-typography-global-type-scale-step0);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-regular);line-height:var(--prism-typography-global-line-height-regular);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-40)}.prism-button,button{font-size:var(--prism-typography-global-type-scale-step-1);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-bold);line-height:var(--prism-typography-global-line-height-regular);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-100)}.prism-caption,caption,figcaption{font-size:var(--prism-typography-global-type-scale-step-1);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-regular);line-height:var(--prism-typography-global-line-height-regular);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-40)}.prism-overline{font-size:var(--prism-typography-global-type-scale-step-2);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-regular);line-height:var(--prism-typography-global-line-height-larger);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-120);text-transform:uppercase;}.prism-microlabel{font-size:var(--prism-typography-global-type-scale-step-3);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-bold);line-height:var(--prism-typography-global-line-height-largest);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-120);text-transform:uppercase;}.pwc-none{display:none}.pwc-visually-hidden{border:0;height:0;margin:0;padding:0;outline:0;overflow:hidden;position:absolute;white-space:nowrap;width:1px;appearance:none}.pwc-input-label{position:absolute;left:0;top:50%;transform:translateY(-50%);transition:0.1s ease-out;transform-origin:left top;pointer-events:none}.pwc-input{outline:none;background-color:transparent;color:var(--prism-color-theme-ink);padding:var(--prism-spacing-global-small) 0;width:100%}";
const PrismMenuBaseStyle1 = sharedCss;

const PrismMenuBase = /*@__PURE__*/ proxyCustomElement(class PrismMenuBase extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.keyDownHandler = this.handleKeyDown.bind(this);
        this.visible = undefined;
        this.submenu = undefined;
        this.parentMenu = undefined;
        this.selectMenu = undefined;
        this.editableSelectMenu = undefined;
        this.searchQuery = '';
    }
    /**
     * Watcher for the 'visible' property.
     * It clears the focused menu item index if visible is false.
     */
    watchVisible(visible) {
        var _a;
        const selectedMenuItemIndex = (_a = this.menuItemElements) === null || _a === void 0 ? void 0 : _a.findIndex((item) => item.selected);
        if (!visible && this.selectMenu && selectedMenuItemIndex !== -1) {
            // If there's a selected menu item, assign its index to the focused menu item index when the menu closes.
            this.focusedMenuItemIndex = selectedMenuItemIndex;
        }
        else if (!visible) {
            // Clear the focused menu item index when the menu closes.
            this.focusedMenuItemIndex = undefined;
        }
    }
    /**
     * Lifecycle method called when the component is connected to the DOM.
     * Adds a keydown event listener.
     */
    connectedCallback() {
        if (this.visible) {
            this.hostElement.addEventListener('keydown', this.keyDownHandler);
        }
    }
    /**
     * Lifecycle method called when the component is disconnected from the DOM.
     * Removes the keydown event listener.
     */
    disconnectedCallback() {
        this.hostElement.removeEventListener('keydown', this.keyDownHandler);
    }
    /**
     * Handles the keydown event for the specified element.
     */
    handleKeyDown(event) {
        if (this.visible) {
            let eventHandled = true;
            switch (event.key) {
                case 'ArrowDown':
                    this.handleArrowDown();
                    break;
                case 'ArrowUp':
                    this.handleArrowUp();
                    break;
                case 'Escape':
                case 'Tab': {
                    // Because we are moving the menu base to the overlay,
                    // prism-menu key listener does not get the event
                    // Dispatch the Escape and Tab keydown events to the prism-menu to close the menu
                    const newEvent = new KeyboardEvent('keydown', { key: event.key });
                    this.parentMenu.dispatchEvent(newEvent);
                    break;
                }
                default:
                    if (event.key.length === 1) {
                        this.updateSearchQuery(this.searchQuery + event.key);
                        this.focusMatchingOption();
                        break;
                    }
                    eventHandled = false;
            }
            if (eventHandled) {
                event.preventDefault();
                event.stopPropagation();
            }
        }
    }
    render() {
        return (h("div", { key: '485602b6eacdd3e3012ef4075c3c9c6205a06f73', role: "menu", tabindex: "0", class: `pwc-menu-wrapper ${this.visible ? 'pwc-visible' : ''}` }, h("slot", { key: '545d65c88f3a7550f55284a78945a69ec247e8e8', onSlotchange: (e) => this.slotChange(e) })));
    }
    /**
     * Get all the enabled menu items of this menu.
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    slotChange(event) {
        if (this.visible) {
            this.menuItemElements = event.target.assignedElements().filter((menuItem) => !menuItem.disabled);
        }
    }
    /**
     * Handles the "ArrowDown" key press event.
     *
     * This method moves the focus to the next menu item in the list. If the focused menu item index
     * is not set or is -1, it sets the focus to the first menu item. If the submenu is present,
     * it starts focusing from the second menu item.
     */
    handleArrowDown() {
        if (this.focusedMenuItemIndex === undefined || this.focusedMenuItemIndex === -1) {
            if (this.submenu) {
                this.focusedMenuItemIndex = 1;
            }
            else {
                this.focusedMenuItemIndex = 0;
            }
        }
        else {
            this.focusedMenuItemIndex = (this.focusedMenuItemIndex + 1) % this.menuItemElements.length;
        }
        if (this.editableSelectMenu) {
            // Make the next menu item active
            this.menuItemElements[this.focusedMenuItemIndex].active = true;
        }
        else {
            this.menuItemElements[this.focusedMenuItemIndex].focus();
        }
    }
    /**
     * Handles the "ArrowUp" key press event.
     *
     * This method moves the focus to the previous menu item in the list. If the focused menu item index
     * is not set or is 0, it sets the focus to the last menu item.
     */
    handleArrowUp() {
        if (this.focusedMenuItemIndex === undefined || this.focusedMenuItemIndex === 0) {
            this.focusedMenuItemIndex = this.menuItemElements.length - 1;
        }
        else {
            this.focusedMenuItemIndex = (this.focusedMenuItemIndex - 1) % this.menuItemElements.length;
        }
        if (this.editableSelectMenu) {
            // Make the next menu item active
            this.menuItemElements[this.focusedMenuItemIndex].active = true;
        }
        else {
            this.menuItemElements[this.focusedMenuItemIndex].focus();
        }
    }
    /**
     * Update the search query and reset the debounce timer
     */
    updateSearchQuery(query) {
        this.searchQuery = query;
        // Clear any existing debounce timer
        if (this.debounceTimer) {
            clearTimeout(this.debounceTimer);
        }
        // Set a new debounce timer to reset the search query after a second
        this.debounceTimer = setTimeout(() => {
            this.searchQuery = '';
        }, 1000);
    }
    /**
     * Focus the matching menu item based on the current search query
     */
    focusMatchingOption() {
        // Find the index of the first menu item that matches the search query
        const matchIndex = this.menuItemElements.findIndex((item) => item.value.toLowerCase().startsWith(this.searchQuery.toLowerCase()));
        if (matchIndex !== -1 && !this.editableSelectMenu) {
            this.focusedMenuItemIndex = matchIndex;
            this.menuItemElements[this.focusedMenuItemIndex].focus();
        }
    }
    static get delegatesFocus() { return true; }
    get hostElement() { return this; }
    static get watchers() { return {
        "visible": ["watchVisible"]
    }; }
    static get style() { return PrismMenuBaseStyle0 + PrismMenuBaseStyle1; }
}, [17, "prism-menu-base", {
        "visible": [4],
        "submenu": [4],
        "parentMenu": [16],
        "selectMenu": [4, "select-menu"],
        "editableSelectMenu": [4, "editable-select-menu"],
        "searchQuery": [32]
    }, undefined, {
        "visible": ["watchVisible"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["prism-menu-base"];
    components.forEach(tagName => { switch (tagName) {
        case "prism-menu-base":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, PrismMenuBase);
            }
            break;
    } });
}

export { PrismMenuBase as P, defineCustomElement as d };

